import { useTranslations } from 'use-intl';

import SurveyAiFormsAiSectionHeader from './survey-ai-forms-ai-section-header';
import SurveyAiFormsProgressDots from './survey-ai-forms-progress-dots';
import SurveyAiFormsSubmitButton from './survey-ai-forms-submit-button';
import type { ViewMode } from './survey-ai-forms.types';

interface Question {
  id: string;
}

interface Props {
  onSubmit: () => void;
  totalQuestions: number;
  questions?: Question[];
  onQuestionClick?: (questionId: string) => void;
  onViewModeToggle?: () => void;
  viewMode?: ViewMode;
  progress: number;
  estimatedTotalTimeInSeconds: number;
  isSubmitting?: boolean;
  canSubmit?: boolean;
}

export default function SurveyAiFormsAiSectionCompletion({
  onSubmit,
  totalQuestions,
  questions,
  onQuestionClick,
  onViewModeToggle,
  viewMode = 'ai',
  progress,
  estimatedTotalTimeInSeconds,
  isSubmitting = false,
  canSubmit = false,
}: Props) {
  const t = useTranslations('Common');
  const tCompletion = useTranslations('Completion');

  return (
    <div
      data-test='ai-section-completion'
      className='flex h-full flex-col justify-between rounded-4xl px-4 py-8 sm:px-6'
    >
      {/* Header */}
      <SurveyAiFormsAiSectionHeader
        progress={progress}
        estimatedTotalTimeInSeconds={estimatedTotalTimeInSeconds}
        viewMode={viewMode}
        onViewModeToggle={onViewModeToggle}
      />

      {/* Content - Completion Message */}
      <div className='mx-auto flex w-full max-w-180 flex-col items-start gap-8'>
        <h2 className='[font-family:var(--brand-font)] text-[28px]/10.5 font-semibold'>
          <span className='text-(--brand-secondary)'>
            {tCompletion('thankYou')}{' '}
          </span>
          {/* oxlint-disable jsx-a11y/prefer-tag-over-role */}
          <span role='img' aria-label={t('smilingFaceAria')}>
            😊
          </span>
          {/* oxlint-enable jsx-a11y/prefer-tag-over-role */}
        </h2>
        <SurveyAiFormsSubmitButton
          onClick={onSubmit}
          loading={isSubmitting}
          disabled={!canSubmit}
        />
      </div>

      {/* Footer - Progress Dots */}
      <SurveyAiFormsProgressDots
        currentIndex={totalQuestions - 1}
        total={totalQuestions}
        questions={questions}
        onQuestionClick={onQuestionClick}
      />
    </div>
  );
}
